import $ from 'jquery';
import PubSub from 'Utils/pub-sub';
import BreakpointDispatcher from 'Utils/breakpoint-dispatcher';


export default class ArticleTemplate {


  constructor() {
    BreakpointDispatcher.start();
    let self = this;

    this.el = $('.js-article');
    this.aside = this.el.find('.js-article_aside');
    this.mobileInitialPos = this.getAsidePosition();
    this.isSticky = false;
    this.stickyClass = $('.js-header-auth').length ? 'is-sticky-co' : 'is-sticky';

    this.setInitialState();
    this.handleEvents();
  }

  setInitialState() {
    this.templateWidth = $('.dcw_article-template').width();
    this.lastScrollPos = $(window).scrollTop();
    this.initialPos = $('.js-article_main').offset().top;
  }

  handleEvents() {
    this.handleResizeCallback = this.handleResize(this);

    if (!this.isMobileWidth()) {
      PubSub.subscribe('resize', this.handleResizeCallback);

      PubSub.subscribe('sticky:enter', () => {
        if (this.isMobileWidth()) return;

        this.aside.addClass(this.stickyClass);
        this.setAsideWidth();       
      });

      PubSub.subscribe('sticky:leave', () => {
        this.aside.removeClass(this.stickyClass);
      });

      PubSub.subscribe('resize:mobile', this.handleMobile(this));
    }

    else {
      this.handleMobileScroll();
    }

    this.handleBreakpointChange();
  }

  isMobileWidth() {
    return BreakpointDispatcher.getState() === BreakpointDispatcher.breakpoint.MOBILE;
  }

  isAsideAlreadySticky() {
    if (!this.isMobileWidth()) {
      return false;
    } else {
      return $(window).scrollTop() >= this.mobileInitialPos;
    }
  }

  handleResize(self) {
    return function handleResize () {
      if (self.isMobileWidth()) return;

      self.setInitialState();   
      self.setAsideWidth();   
    };
  }

  handleMobileScroll() {
    window.addEventListener('scroll', e => {
      switch (this.isSticky) {
        case false:
            if ($(window).scrollTop() > this.mobileInitialPos) {
            this.isSticky = true;
            this.aside.addClass(this.stickyClass);
          }
        break;
        case true:
          if ($(window).scrollTop() <= this.mobileInitialPos) {
            this.isSticky = false;
            this.aside.removeClass(this.stickyClass);
          }
        break;
      }
    });
  }

  handleMobile(self) {
    return function handleMobile () {
      PubSub.unsubscribe('resize', self.handleResizeCallback);
      self.aside.css('width', '100%');
    };
  }

  handleBreakpointChange() {
    PubSub.subscribe('resize:tablet', () => {
      this.setInitialState();
      this.setAsideWidth();
      PubSub.subscribe('resize', this.handleResizeCallback);
    });
  }

  getAsidePosition() {
    return this.el.find('.dcw_article-header').offset().top;
  }

  setAsideWidth() {
    this.aside.css(
      'width', 
      (1/3) * this.templateWidth + 'px'
      );
  }
}


// WEBPACK FOOTER //
// ./src/templates/article/article-template.js